var moduleMap = {
	"./Contacts": () => {
		return Promise.all([__webpack_require__.e(3567), __webpack_require__.e(3197), __webpack_require__.e(3943), __webpack_require__.e(4914), __webpack_require__.e(9148), __webpack_require__.e(7609), __webpack_require__.e(64), __webpack_require__.e(5820), __webpack_require__.e(3720), __webpack_require__.e(2645), __webpack_require__.e(7875), __webpack_require__.e(6659), __webpack_require__.e(2569)]).then(() => (() => ((__webpack_require__(32472)))));
	},
	"./LearnerIndex": () => {
		return Promise.all([__webpack_require__.e(3567), __webpack_require__.e(3197), __webpack_require__.e(4914), __webpack_require__.e(7609), __webpack_require__.e(64), __webpack_require__.e(5820), __webpack_require__.e(3720), __webpack_require__.e(7875), __webpack_require__.e(7379)]).then(() => (() => ((__webpack_require__(37379)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});